// File: src/App.js
// Description: Fixed main application component - removed gap-causing wrapper

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';

// Import components
import Navbar from './components/common/Navbar';
import Footer from './components/common/Footer';

// Import pages
import Home from './pages/Home';
import About from './pages/About';
import ReadingRoom from './pages/ReadingRoom';
import MainFaculties from './pages/MainFaculties';
import OfferingDegrees from './pages/OfferingDegrees';
import Faculties from './pages/Faculties';
import Donation from './pages/Donation';
import Gallery from './pages/Gallery';
import Notices from './pages/Notices';
import CurrentActivities from './pages/CurrentActivities';
import FoundationActivities from './pages/FoundationActivities';

// Import only the main globals.css - it handles all other imports
import './styles/globals.css';

function App() {
  return (
    <LanguageProvider>
      <Router>
        <div className="App">
          <Navbar />
          {/* 🔧 FIX: Removed main wrapper that was causing the gap */}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/reading-room" element={<ReadingRoom />} />
            <Route path="/main-faculties" element={<MainFaculties />} />
            <Route path="/offering-degrees" element={<OfferingDegrees />} />
            <Route path="/faculties" element={<Faculties />} />
            <Route path="/donation" element={<Donation />} />
            <Route path="/gallery" element={<Gallery />} />
	    <Route path="/notices" element={<Notices />} />
	    <Route path="/current-activities" element={<CurrentActivities />} />
	    <Route path="/foundation-activities" element={<FoundationActivities />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;